
import { Link } from 'react-router-dom';

interface BlogBreadcrumbProps {
  postTitle: string;
}

export default function BlogBreadcrumb({ postTitle }: BlogBreadcrumbProps) {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://tgweb.com.br/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Blog',
        item: 'https://tgweb.com.br/blog',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: postTitle,
      },
    ],
  };

  // Guard against missing or non‑string postTitle to avoid runtime JSON errors
  const safeTitle = typeof postTitle === 'string' ? postTitle : '';

  // Update schema with the safe title
  const safeBreadcrumbSchema = {
    ...breadcrumbSchema,
    itemListElement: breadcrumbSchema.itemListElement.map((item, index) =>
      index === 2 ? { ...item, name: safeTitle } : item
    ),
  };

  return (
    <>
      <script
        type="application/ld+json"
        // Using dangerouslySetInnerHTML is required for structured data
        dangerouslySetInnerHTML={{ __html: JSON.stringify(safeBreadcrumbSchema) }}
      />
      <nav
        aria-label="Breadcrumb"
        className="flex items-center gap-2 text-sm text-neutral-500 flex-wrap"
      >
        <Link
          to="/"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          Home
        </Link>
        <i className="ri-arrow-right-s-line text-neutral-400"></i>
        <Link
          to="/blog"
          className="hover:text-primary transition-colors cursor-pointer"
        >
          Blog
        </Link>
        <i className="ri-arrow-right-s-line text-neutral-400"></i>
        <span className="text-neutral-700 font-medium line-clamp-1 max-w-xs">
          {safeTitle}
        </span>
      </nav>
    </>
  );
}
